import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { BUSINESS_PHONE, BUSINESS_EMAIL, OFFICE_LOCATION } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="ae-bg-navy text-white border-t border-[#C5A46D]/25">
      <div className="ae-container py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-2.5 mb-5">
            <div className="w-10 h-10 rounded-md bg-gradient-to-br from-[#C5A46D] to-[#8E7340] flex items-center justify-center">
              <span className="font-display font-bold text-[#101827] text-lg">A</span>
            </div>
            <div>
              <div className="font-bold tracking-wide">APURBA ESTATE</div>
              <div className="text-[11px] text-[#C5A46D] tracking-[0.2em] uppercase">Real Estate · Survey · Advisory</div>
            </div>
          </div>
          <p className="text-white/70 text-sm leading-relaxed max-w-sm">
            A Kolkata-region real estate consultancy combining property transactions, digital land surveying,
            and documentation support under one trusted brand.
          </p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Instagram, Linkedin].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:text-[#C5A46D] hover:border-[#C5A46D]/50 transition" data-testid={`footer-social-${i}`}>
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[#C5A46D] text-xs font-bold tracking-[0.2em] uppercase mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm text-white/75">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/properties" className="hover:text-white">Properties</Link></li>
            <li><Link to="/projects" className="hover:text-white">Projects</Link></li>
            <li><Link to="/blog" className="hover:text-white">Knowledge</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[#C5A46D] text-xs font-bold tracking-[0.2em] uppercase mb-4">Services</h4>
          <ul className="space-y-2.5 text-sm text-white/75">
            <li><Link to="/land-survey" className="hover:text-white">Land Survey</Link></li>
            <li><Link to="/documentation" className="hover:text-white">Documentation</Link></li>
            <li><Link to="/planning" className="hover:text-white">Property Planning</Link></li>
            <li><Link to="/partner" className="hover:text-white">Partner With Us</Link></li>
            <li><Link to="/sell" className="hover:text-white">List Your Property</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-[#C5A46D] text-xs font-bold tracking-[0.2em] uppercase mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#C5A46D] shrink-0" /><span>{OFFICE_LOCATION}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-[#C5A46D] shrink-0" /><a href={`tel:${BUSINESS_PHONE}`} className="hover:text-white">{BUSINESS_PHONE}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-[#C5A46D] shrink-0" /><a href={`mailto:${BUSINESS_EMAIL}`} className="hover:text-white">{BUSINESS_EMAIL}</a></li>
          </ul>
          <div className="mt-5 text-xs text-white/50">
            Business hours: Mon – Sat, 10:00 AM – 7:00 PM
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="ae-container py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/55">
          <div>© {new Date().getFullYear()} Apurba Estate. Independent real estate consultancy & technical services.</div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/disclaimer" className="hover:text-white">Disclaimer</Link>
            <Link to="/admin/login" className="hover:text-[#C5A46D]">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
